module.exports = __webpack_public_path__ + "media/images/patterns/people-bg-1e95277027340fe9acf351c44e6e53dd.svg";